import React from "react";

const Button = ({ label, icon, onClick, isActive }) => {
  const buttonClassName = `flex items-center w-[90%] py-2 px-4 mt-2  bg-whwit rounded-lg hover:bg-gray-200 hover:text-black ${
    isActive ? "bg-gray-200 text-black" : "text-gray-300"
  }`;

  return (
    <button className={buttonClassName} onClick={onClick}>
      {icon && <span className="mr-2">{icon}</span>}
      {label}
    </button>
  );
};

export default Button;
